export default __webpack_public_path__ + "static/pptx-icon-no-bg-526512097a922d436b6b535a9fc4109a.png";